import { BackgroundElements } from "src/ts/site/BackgroundElements";
export class Header {
    constructor() {
        this.SELECTOR_NAV = "#mobile-nav";
        this.MOBILE_MENU = "#mobile-menu";
        this.SELECTOR_NAV_TOGGLE = '[jss="nav-toggle"]';
        this.SELECTOR_NAV_ANIM_ITEM = '[jss="nav-anim-item"]';
        this.SELECTOR_BACKDROP = '.site-wrapper [jss="backdrop"]';
        this.SELECTOR_MOBILE_NAV_FIRST_FOCUSABLE = ".home";
        this.CLASS_BACKDROP = "bg-site-mask";
        this.SCROLL_AMOUNT_MIN = 50; //when STATE_NAV_HIDDEN is applied
        this.SCROLL_AMOUNT_MAX = 50; //when STATE_SCROLLED is applied
        this.ITEM_ANIMATION_DELAY = 350;
        this.STATE_SCROLLED = "header--scrolled";
        this.STATE_NAV_VISIBLE_DT = "nav-visible";
        this.STATE_ARIA_NAV_OPEN = "true";
        this.STATE_ARIA_NAV_CLOSED = "false";
        this.NAV_BUTTON_ACTIVE_CLASS = "is-active";
        this.NAV_OPEN_BODY_CLASS = "nav_open";
        this.navHideTimeout = 0;
        this.isNavOpen = false;
        this.header = document.querySelector("header.header");
        this.navigation = document.querySelector(this.SELECTOR_NAV);
        this.navButton = this.navigation.querySelector(this.SELECTOR_NAV_TOGGLE);
        this.animationItems = this.header.querySelectorAll(this.SELECTOR_NAV_ANIM_ITEM);
        //this.search = new Search();
        this.mobileMenu = this.navigation.querySelector(this.MOBILE_MENU);
        this.navButton.addEventListener("keydown", (e) => this.onNavButtonPress(e));
        this.navButton.addEventListener("click", (e) => this.onNavButtonClick(e));
        window.addEventListener("resize", () => this.onWindowResize());
        window.addEventListener("scroll", (e) => this.onWindowScroll(e));
        this.onWindowResize();
        this.backdrop = document.querySelector("body > " + this.SELECTOR_BACKDROP);
        this.backdrop.addEventListener("touchmove", (e) => this.onBgTouchMove(e));
        this.backdrop.addEventListener("click", () => this.closeNav());
        this.navigation.addEventListener("touchmove", (e) => this.killEventBubbling(e), true);
        window.addEventListener("keydown", (e) => this.onWindowKeydown(e));
    }
    getSearch() {
        return this.search;
    }
    killEventBubbling(e) {
        e.stopPropagation();
        if (e.bubbles) {
            //e.preventDefault();
        }
    }
    onBgTouchMove(e) {
        e.preventDefault();
        e.stopPropagation();
        return false;
    }
    onNavLinkClick(e) {
        if (this.isNavOpen) {
            this.closeNav();
        }
    }
    onWindowKeydown(e) {
        if (e.code == "Escape") {
            this.closeNav();
        }
    }
    onNavButtonPress(e) {
        if (e.keyCode == 32 || e.keyCode == 13) {
            if (!this.isNavOpen) {
                this.openNav(true);
            }
            else {
                this.closeNav();
            }
            return false;
        }
    }
    onNavButtonClick(e) {
        if (!this.isNavOpen) {
            this.openNav();
        }
        else {
            this.closeNav();
        }
        return false;
    }
    closeNav() {
        if (!this.isNavOpen) {
            return;
        }
        this.isNavOpen = false;
        this.navButton.classList.remove(this.NAV_BUTTON_ACTIVE_CLASS);
        this.navButton.setAttribute("aria-pressed", this.STATE_ARIA_NAV_CLOSED);
        this.navButton.removeAttribute("aria-expanded");
        const burger = this.navButton.querySelector(".burger");
        if (burger) {
            burger.classList.remove("in");
            burger.classList.add("out");
        }
        document.body.style.overflow = "";
        document.body.style.overscrollBehavior = "";
        this.mobileMenu.style.translate = "";
        this.mobileMenu.setAttribute("focusable", "false");
        this.backdrop.classList.remove(this.CLASS_BACKDROP);
        setTimeout(() => {
            this.animationItems.forEach((elem) => {
                elem.style.opacity = "";
                elem.style.transform = "";
            });
            this.mobileMenu.style.visibility = "";
            this.backdrop.classList.add("invisible");
        }, this.ITEM_ANIMATION_DELAY);
        this.backgroundElements.enable();
        document.body.classList.remove(this.NAV_OPEN_BODY_CLASS);
    }
    openNav(withFocus = false) {
        if (this.isNavOpen) {
            return;
        }
        this.backdrop.classList.remove("invisible");
        this.backdrop.classList.add(this.CLASS_BACKDROP);
        if (this.backgroundElements == null) {
            const siteWrapper = document.querySelector("body .site-wrapper");
            if (siteWrapper) {
                const mainAndFooter = siteWrapper.querySelectorAll("main, footer");
                const elements = [];
                mainAndFooter.forEach((container) => {
                    const found = container.querySelectorAll("a[href], area[href], input, select, textarea, button, iframe, object, embed, *[tabindex], *[contenteditable]");
                    elements.push(...Array.from(found));
                });
                const skipToContent = document.querySelectorAll("a.skip-to-content");
                const navButtons = document.querySelectorAll('[jss="nav-wrapper"] > button, [jss="nav-wrapper"] > a');
                const allElements = elements.concat(Array.from(skipToContent), Array.from(navButtons));
                const filtered = allElements.filter((elem) => {
                    const tabindex = elem.getAttribute("tabindex");
                    const disabled = elem.hasAttribute("disabled");
                    const style = window.getComputedStyle(elem);
                    const hidden = style.display === "none" || style.visibility === "hidden" || style.opacity === "0";
                    return tabindex !== "-1" && !disabled && !hidden;
                });
                this.backgroundElements = new BackgroundElements(filtered);
            }
            else {
                this.backgroundElements = new BackgroundElements([]);
            }
        }
        this.isNavOpen = true;
        this.backgroundElements.disable();
        document.body.style.overflow = "hidden";
        document.body.style.overscrollBehavior = "contain";
        this.navButton.classList.add(this.NAV_BUTTON_ACTIVE_CLASS);
        this.navButton.setAttribute("aria-pressed", this.STATE_ARIA_NAV_OPEN);
        this.navButton.setAttribute("aria-expanded", "true");
        const burger = this.navButton.querySelector(".burger");
        if (burger) {
            burger.classList.remove("out");
            burger.classList.add("in");
        }
        this.animateContentIn();
        document.body.classList.add(this.NAV_OPEN_BODY_CLASS);
        this.mobileMenu.scrollTop = 0;
        this.mobileMenu.style.translate = "0 0";
        this.mobileMenu.style.visibility = "visible";
        this.mobileMenu.setAttribute("focusable", "true");
        if (withFocus) {
            const firstFocusable = this.mobileMenu.querySelector(this.SELECTOR_MOBILE_NAV_FIRST_FOCUSABLE);
            if (firstFocusable) {
                firstFocusable.focus();
            }
        }
    }
    animateContentIn() {
        this.animationItems.forEach((elem, index) => {
            setTimeout(() => {
                elem.style.opacity = "1";
                elem.style.translate = "0 0";
            }, this.ITEM_ANIMATION_DELAY + 10 + index * 15);
        });
    }
    onWindowResize() {
        if (window.innerWidth >= 1024) {
            if (this.isNavOpen) {
                this.closeNav();
            }
        }
    }
    onWindowScroll(e) {
        if (this.isNavOpen) {
            return;
        }
        const newY = window.scrollY;
        if (newY > this.lastScrollPosition && newY > this.SCROLL_AMOUNT_MIN) {
            this.header.style.translate = "translateY(-100%)";
            this.navButton.style.transform = "translateX(300%)";
            document.body.classList.remove(this.STATE_NAV_VISIBLE_DT);
        }
        else {
            this.header.style.transform = "";
            this.navButton.style.transform = "";
            document.body.classList.add(this.STATE_NAV_VISIBLE_DT);
        }
        if (newY > this.SCROLL_AMOUNT_MAX) {
            if (!this.header.classList.contains(this.STATE_SCROLLED)) {
                this.header.classList.add(this.STATE_SCROLLED);
                clearTimeout(this.navHideTimeout);
            }
        }
        else {
            if (this.header.classList.contains(this.STATE_SCROLLED)) {
                clearTimeout(this.navHideTimeout);
                this.header.classList.remove(this.STATE_SCROLLED);
            }
        }
        this.lastScrollPosition = newY;
    }
}
